import React from "react";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import { Icon } from "@material-ui/core";
import Carousel from "../../../catalog/common/Carousel";

const Portfolio2 = ({data}) => {

  return (
    <section className="section" id="portfoli2">
      <div className="container text-center">
        <div className="mb-8">
          <h1>Nos Clients</h1>
          <p>
         
          </p>
        </div>

        <Carousel carouselId="portfolio-2" slidesPerView={6}>
          {Object.values(data).map((portfolio, index) => (
            <Card className="relative h-full card" key={index}>
              <img
                className="w-full block"
                src={portfolio.logo}
                alt="portfolio"
              />
              <div className="flex-column justify-between">
                <div className="px-4 pt-4">
                  <h5 className="m-0 text-16 font-bold">{portfolio.name}</h5>
                  {/* <p className="mb-4">{portfolio.description}</p> */}
                </div>
              </div>
            </Card>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default Portfolio2;
